import * as React from 'react';

import ReactDOM, { render } from 'react-dom';

import { UiButton } from '../ui/ui-button';
import { UiDialog } from '../ui/ui-dialog';

import { ErrorMessage } from './error-message';

type Props = {
  close: () => void;
  overrideMui?: boolean;
};

let resolve: Function | null = null;

export const ErrorMessageDialog = ({ close, overrideMui }: Props) => {
  const handleClose = () => {
    if (resolve) {
      resolve();
    }
    close();
  };

  return (
    <UiDialog onClose={handleClose} title="An unexpected error has occurred">
      <UiDialog.Content>
        <ErrorMessage />
      </UiDialog.Content>
      <UiDialog.Actions>
        <UiButton
          className={overrideMui ? 'button-primary' : undefined}
          variant="primary"
          onClick={handleClose}
        >
          Ok
        </UiButton>
      </UiDialog.Actions>
    </UiDialog>
  );
};

export const error = () => {
  const containerElement = document.createElement('div');
  document.body.appendChild(containerElement);

  const onClose = () => {
    ReactDOM.unmountComponentAtNode(containerElement);
    containerElement.remove();
  };

  render(<ErrorMessageDialog overrideMui close={onClose} />, containerElement);
  return new Promise((res) => {
    resolve = res;
  });
};
